<template>
  <div>
    <v-stepper v-model="step" class="elevation-0 transparent">
      <v-stepper-header class="elevation-0">
        <template v-for="(s, index) in filteredSteps">
          <v-divider v-if="index" :key="index + 's'"></v-divider>
          <v-stepper-step
            :complete="step > index + 1"
            :step="index + 1"
            :key="index"
          >
            {{ s.title }}
          </v-stepper-step>
        </template>
      </v-stepper-header>
      <v-divider />
      <v-stepper-items style="overflow-y: auto; min-height: calc(100vh - 102px);" class="transparent">
        <v-stepper-content
          v-for="(s, index) in filteredSteps"
          :key="index"
          :step="index + 1"
          class="pb-2"
        >
          <component
            v-if="index + 1 == step"
            :is="s.component || 'div'"
            :token="token"
            :data="data"
            :cart.sync="cart"
            :client.sync="client"
            :payment.sync="payment"
            :selectedParty="selectedParty"
            @select-party="selectedParty = $event"
            @next="step++"
            @prev="step--"
            @restart="restart"
          ></component>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <CartSideBar
      :token="token"
      :cart.sync="cart"
      :step="filteredSteps[step - 1]"
      :selectedParty="selectedParty"
      :payment.sync="payment"
      @next="step++"
      @prev="step--"
      @restart="restart"
    />
  </div>
</template>

<script>
import PartySelect from "./PartySelect.vue";
import TicketsSelector from "./TicketsSelector.vue";
import CartSideBar from "./CartSideBar.vue";
import ClientIdentification from "./ClientIdentification.vue";
import PaymentConciliate from "./PaymentConciliate.vue";
import payment from "../../../utils/payment";

export default {
  name: "MainVirtualPos",
  components: {
    PartySelect,
    TicketsSelector,
    CartSideBar,
    ClientIdentification,
    PaymentConciliate,
  },
  props: {
    token: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      step: 1,
      steps: [
        {
          id: "party",
          title: "Evento",
          condition: (that) => !that.data?.session?.Party,
          component: "PartySelect",
        },
        {
          id: "tickets",
          title: "Ingressos",
          component: "TicketsSelector",
        },
        {
          id: "client",
          title: "Identificação",
          component: "ClientIdentification",
        },
        {
          id: "payment",
          title: "Pagamento",
          component: "PaymentConciliate",
        },
      ],

      // data
      selectedParty: null,
      cart: {},
      payment: null,
      client: null,
    };
  },
  methods: {
    restart() {
      this.step = 1;
      this.selectedParty = null;
      this.cart = {};
      this.payment = null;
      this.client = null;
    },
  },
  computed: {
    filteredSteps() {
      return this.steps.filter(
        (step) => !step.condition || step.condition(this)
      );
    },
  },
  watch: {
    selectedParty(newParty) {
      if (!newParty) this.cart = {};
    },
  },
};
</script>
